<template>
  <div>
    <div class="bottom-header">
      <div class="opts">
        <hl-button @click="handleTsl" v-if="tslRole && tableData && tableData.length > 0">{{
          $t('Product.TSL')
        }}</hl-button>
      </div>
    </div>
    <Alert>
      {{ $t('Product.tips3') }}
      <hl-button type="text" @click="toDraft">{{ $t('Product.editDraft') }}</hl-button>
    </Alert>
    <CommonTable
      ref="table"
      :data="tableData"
      :total="total"
      :table-json="tablejson"
      :needPagination="false"
    >
    </CommonTable>
    <ProductTSL
      :id="id"
      v-if="visible"
      @refresh="formSearch(cacheData, cachePage)"
      :visible.sync="visible"
      :roleChildList="tslRoleChildList"
    />
  </div>
</template>

<script>
import Alert from '@/components/Alert'
import ProductTSL from '../../ProductTSL'

import { format, formatTime, formatNumWithComma, createImgUrl } from '@/utils/utils'
import { enbaleDisableStatus } from '@/config/status'
import { productTypeTag } from '@/config/tag'
import { getRoleByOperationCode, getRoute } from '@/authorized'

import { blueColor } from '@/style/var.scss'

import tablejson from '../../Model/Tablejson.TSL'
export default {
  name: 'index',
  components: {
    Alert,
    ProductTSL
  },
  props: {
    tableData: {
      type: Array,
      default: () => []
    },
    id: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      enbaleDisableStatus,
      productTypeTag,
      blueColor,
      tablejson,
      visible: false
    }
  },
  computed: {
    roleChildList() {
      let path = '/product/model'.toLowerCase()
      let productModelRole = getRoute(path, this.$store.state.menus) || {}
      let detailRole = getRoleByOperationCode(productModelRole.childList, 'detail')
      return detailRole && detailRole.isPermission === 'Y' ? detailRole.childList : []
    },
    // 物模型TSL
    tslRole() {
      let val = getRoleByOperationCode(this.roleChildList, 'tsl')
      return val ? val.isPermission === 'Y' : false
    },
    tslRoleChildList() {
      let role = getRoleByOperationCode(this.roleChildList, 'tsl')
      return role ? role.childList : []
    }
  },
  methods: {
    toDraft() {
      this.$router.push({
        name: 'ProductDraft',
        query: {
          ...this.$route.query
        }
      })
    },
    handleTsl() {
      this.visible = true
    }
  }
}
</script>

<style lang="scss" scoped>
.bottom-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  .left {
    display: flex;
    align-content: center;
  }
  h3 {
    margin-right: 16px;
    line-height: 32px;
    font-size: 16px;
    color: #333333;
  }
}
.hl-alert {
  margin-top: 16px;
  margin-bottom: 8px;
}
</style>
